import { CA_PROVINCES, matchesProvince } from './provinces';

// Clean values for comparison/display only; never rewrite saved host records.
export function cleanLocation(value) {
  return typeof value === 'string'
    ? value.normalize('NFKC').replace(/[\u200B-\u200D\u2060\uFEFF]/g, '').replace(/\s+/g, ' ').trim()
    : '';
}

export function locationKey(value) {
  return cleanLocation(value).toLowerCase();
}

// Strip only stray terminal city commas, not punctuation in compound names,
// full addresses, province data, or legacy campus-region strings.
export function cleanCity(value) {
  return cleanLocation(value).replace(/(?:,\s*)+$/, '').trim();
}

export function canonicalProvince(value) {
  const key = locationKey(value);
  return CA_PROVINCES.find(p =>
    locationKey(p.abbr) === key || locationKey(p.name) === key
  )?.abbr || '';
}

export function hostMatchesProvince(host, selectedProvince) {
  if (!cleanLocation(selectedProvince)) return true;
  const selected = canonicalProvince(selectedProvince);
  if (!selected) return false;
  const saved = canonicalProvince(host.province);
  // Explicit province data wins over legacy campus-region city guesses.
  if (saved) return saved === selected;
  const region = cleanLocation(host.campus_region);
  const explicitRegionProvince = CA_PROVINCES.find(p =>
    region.toLowerCase().includes(p.name.toLowerCase()) ||
    new RegExp(`\\b${p.abbr}\\b`, 'i').test(region)
  );
  if (explicitRegionProvince) return explicitRegionProvince.abbr === selected;
  return matchesProvince(region, selected);
}

export function hostMatchesCity(host, selectedCity) {
  if (!cleanLocation(selectedCity)) return true;
  const selected = cleanCity(selectedCity).toLowerCase();
  return Boolean(selected) && cleanCity(host.city).toLowerCase() === selected;
}

export function hostCityOptions(hosts, selectedProvince = '') {
  const cities = new Map();
  hosts.forEach(host => {
    if (!hostMatchesProvince(host, selectedProvince)) return;
    const city = cleanCity(host.city);
    const key = locationKey(city);
    if (city && !cities.has(key)) cities.set(key, city);
  });
  return [...cities.values()].sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
}
